import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿La TMS puede ayudar si los antidepresivos fallaron?",
    answer:
      "Sí. La TMS está autorizada por la FDA específicamente para adultos cuya depresión no ha mejorado con antidepresivos. Usa impulsos magnéticos, no medicación, y no causa efectos secundarios sistémicos. SAINT® es un protocolo de TMS acelerada de cinco días autorizado por la FDA (K220177).",
  },
  {
    question: "¿Cuántos antidepresivos debo probar antes de la TMS?",
    answer:
      "La depresión resistente al tratamiento se define como la falta de respuesta a al menos dos antidepresivos en dosis y duración adecuadas. La TMS está autorizada para la depresión que no ha respondido a medicación. Su psiquiatra puede determinar si es apropiada para usted.",
  },
  {
    question: "¿La TMS reemplaza a los antidepresivos?",
    answer:
      "No necesariamente. Algunos pacientes combinan TMS con medicación; otros la usan cuando la medicación no ha funcionado. La decisión la toma un psiquiatra según su historial. Nunca suspenda la medicación abruptamente sin supervisión.",
  },
];

export const esCanTmsHelpAfterAntidepressants = makeEsArticle({
  slug: "can-tms-help-after-antidepressants-fail",
  title: "¿La TMS ayuda si los antidepresivos fallan? | Neuro Wellness",
  description:
    "La TMS está autorizada por la FDA para adultos cuya depresión no ha mejorado con antidepresivos. Cómo funciona, para quién es y qué esperar.",
  h1: "¿La TMS puede ayudar después de que fallan los antidepresivos?",
  breadcrumbLabel: "TMS tras antidepresivos",
  shortAnswer:
    "La TMS está autorizada por la FDA específicamente para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. Usa impulsos magnéticos para estimular la corteza prefrontal, un mecanismo distinto a los antidepresivos orales. No causa efectos secundarios sistémicos. SAINT® es un protocolo de TMS acelerada de cinco días autorizado por la FDA (K220177). La idoneidad la determina un psiquiatra tras una evaluación.",
  keyTakeaways: [
    "La TMS está autorizada por la FDA para depresión sin mejora con antidepresivos.",
    "Usa impulsos magnéticos, no medicación.",
    "No causa efectos secundarios sistémicos.",
    "SAINT® es TMS acelerada de cinco días (K220177).",
    "La idoneidad la determina un psiquiatra.",
  ],
  sections: [
    {
      heading: "Para quién es la TMS",
      paragraphs: [
        "La TMS está autorizada por la FDA para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. La depresión resistente al tratamiento se define como la falta de respuesta a al menos dos antidepresivos en dosis y duración adecuadas.",
      ],
    },
    {
      heading: "Cómo funciona",
      paragraphs: [
        "La TMS usa impulsos magnéticos para estimular la corteza prefrontal dorsolateral izquierda. Un curso estándar dura unas seis semanas. SAINT® comprime el tratamiento en cinco días mediante un calendario acelerado, orientación por fMRI y estimulación theta burst.",
      ],
    },
    {
      heading: "Qué esperar",
      paragraphs: [
        "La TMS no es invasiva y no requiere anestesia. Los resultados varían de una persona a otra. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
